import { FamilyStatus } from '../enums/familyStatusEnum'

export const familyStatusMaleOptions = [
    {
      value: FamilyStatus.NotSelected,
      label: {
        eng: 'Prefer not to say',
        rus: 'Не выбрано',
        kz: 'Таңдалмаған',
      }
    },
    {
      value: FamilyStatus.Single,
      label: {
          eng: 'Single',
          rus: 'Не женат',
          kz: 'Үйленген жоқ',
      }
    },
    {
      value: FamilyStatus.Married,
      label: {
          eng: 'Мarried',
          rus: 'Женат',
          kz: 'Үйленген',
      }
    },
  ]
  export const familyStatusFemaleOptions = [
    {
      value: FamilyStatus.NotSelected,
      label: {
        eng: 'Prefer not to say',
        rus: 'Не выбрано',
        kz: 'Таңдалмаған',
      }
    },
    {
      value: FamilyStatus.Single,
      label: {
          eng: 'Single',
          rus: 'Не замужем',
          kz: 'Үйленген жоқ',
      }
    },
    {
      value: FamilyStatus.Married,
      label: {
          eng: 'Мarried',
          rus: 'Замужем',
          kz: 'Үйленген',
      }
    },
  ]
